<p-toast></p-toast>
<div class="grid grid-cols-12 gap-8 p-4">
    <div class="col-span-full lg:col-span-4">
        <div class="card">
            <div class="font-semibold text-xl mb-4">{{ translateServ.dictionary['FILE_UPLOADER_TITLE'] }}</div>
            <p-message severity="error" [style]="{ 'margin-bottom': '1rem' }" class="blinking-warning">
                <span>
                    <b>{{ translateServ.dictionary?.['ATTENTION'] }}</b> {{ translateServ.dictionary?.['ATTENTION_UPL']
                    }}:<br><b>{{viewScopeService.getCurrentCustomerName() }}</b>.
                </span>
            </p-message>
            <p-fileupload name="file" (onSelect)="onFilesSelected($event)" (onUpload)="onUpload($event)"
                (onError)="onError($event)" (onRemove)="onFileRemoved($event)" [multiple]="true"
                accept="application/pdf,image/*,image/tiff,image/tif" maxFileSize="50000000" mode="advanced"
                [url]="uploadApiUrl" [auto]="false" [showUploadButton]="true" [showCancelButton]="true"
                [chooseLabel]="this.translateServ.dictionary['UPLOADER_CHOOSE']"
                [uploadLabel]="this.translateServ.dictionary['UPLOADER_UPLOAD']"
                [cancelLabel]="this.translateServ.dictionary['UPLOADER_CANCEL']"
                [ngClass]="(directionServ.currentDirection$ | async) === 'ltr' ? 'ml-auto' : 'mr-auto'"
                (onClear)="onClear()">
                <ng-template pTemplate="empty">
                    <div class="flex align-items-center justify-content-center p-4">
                        <i class="pi pi-file-arrow-up text-4xl mr-2"></i>
                        <span class="text-lg">{{ translateServ.dictionary['UPLOADER_INSTRUCTION'] }}</span>
                    </div>
                </ng-template>
            </p-fileupload>
        </div>
    </div>

    <div class="col-span-full lg:col-span-8">
        <div class="card">
            <div class="font-semibold text-xl mb-4">{{ translateServ.dictionary['FILE_UPLOADER_TITLE'] }}</div>

            <p-tabView [(activeIndex)]="activeTabIndex">
                <p-tabPanel header="{{ translateServ.dictionary['UPLOADED_FILES_INFO_SUBTITLE'] }}">
                    <ng-template pTemplate="content">
                        <p-table id="uploaded-files-table" styleClass="app-data-table app-data-table--paged"
                            [value]="uploadedFileInfo" [paginator]="true" [totalRecords]="uploadedFileInfo.length"
                            [rows]="getCurrentPageSize(0,uploadedFileInfo.length)"
                            [rowsPerPageOptions]="setPaginator(uploadedFileInfo.length)"
                            (onPage)="onRowsPerPageChange($event, 0, uploadedFileInfo.length)"
                            [showCurrentPageReport]="true" currentPageReportTemplate="{{translateServ.dictionary['TAB_FOOTER_SHOWING']}} {first}
                                                            {{ translateServ.dictionary['TAB_FOOTER_TO'] }} {last} 
                                                            {{ translateServ.dictionary['TAB_FOOTER_OF'] }} {totalRecords} 
                                                            {{ translateServ.dictionary['TAB_FOOTER_ENTRIES']}}"
                            [paginatorDropdownAppendTo]="'body'"
                            [tableStyle]="{'min-width': '50rem'}">
                            <ng-template let-item pTemplate="paginatordropdownitem">
                                {{ item.value === uploadedFileInfo.length ? 'All' : item.value }}
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>{{ translateServ.dictionary['FILE_NAME'] }}</th>
                                    <th>{{ translateServ.dictionary['FILE_SIZE'] }}</th>
                                    <th>{{ translateServ.dictionary['FILE_TYPE'] }}</th>
                                    <th>{{ translateServ.dictionary['FILE_STATUS'] }}</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item>
                                <tr>
                                    <td>{{ item.file.name }}</td>
                                    <td>{{ formatBytes(item.file.size) }}</td>
                                    <td>
                                        <p-tag [value]="getFileTypeLabel(item.file.type)"
                                            [severity]="getFileTypeSeverity(item.file.type)"></p-tag>
                                    </td>
                                    <td>
                                        <p-tag [value]="item.disp_status"
                                            [severity]="getStatusSeverity(item.status)"></p-tag>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="4">{{ translateServ.dictionary['UPLOADED_STAT_EMPTY'] }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </ng-template>
                </p-tabPanel>

                <p-tabPanel header="{{ translateServ.dictionary['UPLOADED_FILES_STAT_SUBTITLE'] }}">
                    <ng-template pTemplate="content">
                        <ng-container *ngIf="jobStatusLoading">
                            <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
                            <div class="p-text-center p-mt-3">{{ translateServ.dictionary['LOADING_JOB_STATUS'] }}</div>
                        </ng-container>

                        <ng-container *ngIf="!jobStatusLoading">
                            <p-table styleClass="app-data-table app-data-table--paged" id="uploaded-jobs-table"
                                [value]="jobStatusData" [totalRecords]="jobStatusData.length" [paginator]="true"
                                [rows]="getCurrentPageSize(1,jobStatusData.length)"
                                [rowsPerPageOptions]="setPaginator(jobStatusData.length)"
                                (onPage)="onRowsPerPageChange($event, 1, jobStatusData.length)"
                                [showCurrentPageReport]="true" currentPageReportTemplate="{{translateServ.dictionary['TAB_FOOTER_SHOWING']}} {first}
                                                            {{ translateServ.dictionary['TAB_FOOTER_TO'] }} {last} 
                                                            {{ translateServ.dictionary['TAB_FOOTER_OF'] }} {totalRecords} 
                                                            {{ translateServ.dictionary['TAB_FOOTER_ENTRIES']}}"
                                [paginatorDropdownAppendTo]="'body'"
                                [tableStyle]="{'min-width': '50rem'}">
                                <ng-template let-item pTemplate="paginatordropdownitem">
                                    {{ item.value === jobStatusData.length ? 'All' : item.value}}
                                </ng-template>
                                <ng-template pTemplate="caption">
                                    <div class="flex items-center">
                                        <h5 class="m-0">{{ translateServ.dictionary['FILE_JOB_STATUS_TITLE'] }}</h5>
                                        <div class="flex align-items-center"
                                            [ngClass]="(directionServ.currentDirection$ | async) === 'ltr' ? 'ml-auto' : 'mr-auto'">
                                            <p-button type="button" icon="pi pi-refresh"
                                                label="{{ translateServ.dictionary['REFRESH'] }}"
                                                styleClass="p-button-outlined p-button-sm"
                                                (click)="manualJobStatusRefresh()"></p-button>
                                        </div>
                                    </div>
                                    <div class="text-xs text-color-secondary mt-2">{{
                                        translateServ.dictionary['AUTO_DATA_REFRESH_INSTRUCTION'] }}
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="FileRecID">{{ translateServ.dictionary['FILE_ID'] }}
                                            <p-sortIcon field="FileRecID"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="OriginalFileName">{{ translateServ.dictionary['FILE_NAME']
                                            }} <p-sortIcon field="OriginalFileName"></p-sortIcon></th>
                                        <!-- <th>{{ translateServ.dictionary['FILE_STATUS'] }}</th> -->
                                        <th>{{ translateServ.dictionary['FILE_PROGRESS'] }}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-job>
                                    <tr>
                                        <td>{{ job.FileRecID }}</td>
                                        <td>{{ job.OriginalFileName }}</td>
                                        <!-- <td>
                                            <p-tag [value]="job.JobRunningStatus" [severity]="getJobStatusSeverity(job.JobRunningStatus)"></p-tag>
                                        </td> -->
                                        <td>
                                            <p-progressBar
                                                [value]="getJobStatusProgressBarValue(job.JobRunningStatus)"></p-progressBar>
                                            <div class="text-xs text-color-secondary text-right mt-1">{{
                                                getJobStatusProgressBarValue(job.JobRunningStatus) }}%</div>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="4" class="p-text-center">{{
                                            translateServ.dictionary['NOT_FOUND_JOB_STATUS'] }}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </ng-container>
                    </ng-template>
                </p-tabPanel>

            </p-tabView>
        </div>
    </div>
</div>